import React from 'react';
import { AuthUser } from '../../../types/auth';

interface Props {
  authUser: AuthUser;
  onOpenSuperAdmin?: () => void;
}

/** Verweist auf den vollwertigen Admin-Bereich (eigener View statt Drawer-Einbettung). */
const MandantenSection: React.FC<Props> = ({ onOpenSuperAdmin }) => (
  <div style={{ padding: '8px 0' }}>
    <p>
      Mandanten, Benutzer und Systeminfos werden im Admin-Bereich verwaltet
      (Navigation oben: <strong>Admin</strong>).
    </p>
    {onOpenSuperAdmin && (
      <button className="btn-edit" onClick={onOpenSuperAdmin}>
        Admin-Bereich öffnen
      </button>
    )}
  </div>
);

export default MandantenSection;
